import { gql, TypedDocumentNode } from '@apollo/client';
import type { ConsumableLineItem } from '../models/ConsumableLineItem';

export const GET_CONSUMABLE_LINE_ITEMS_QUERY: TypedDocumentNode<{ consumableLineItems: ConsumableLineItem[] }, { filter?: {} }> = gql`
  query GetConsumableLineItems($filter: ConsumableLineItemFilterInput) {
    consumableLineItems(where: $filter, order: { description: ASC }) {
      id,
      description,
      consumableLineItemUseType,
      orderQuantity,
      unitQuantity,
      batchQuantity,
      unitCost,
      shippingCost,
      totalQuantity,
      subtotalCost,
      unitTax,
      totalCost,
      totalUnitCost,
      totalBatchCost
    }
  }
`;

export const GET_TOTAL_CONSUMABLE_COST: TypedDocumentNode<{ totalConsumableCost: number }> = gql`
  query GetTotalConsumableCost {
    totalConsumableCost
  }
`;
